/* eslint-disable no-restricted-imports */
import { AdriverEventData } from './adriver';
import { AstraLabEvent } from './astraLab';
import { SolowayPixelData, SolowaySiteIdAlias } from './soloway';
import { WcmConversionId, WcmConversionIdAlias } from './weborama';

export type PixelEventName =
    | 'B2B_ALL_SITE'
    | 'B2B_PROMO_PAGE_SHOWN'
    | 'B2B_EMPLOYER_PAGE_SHOWN'
    | 'B2B_EMPLOYER_AUTHORIZATION'
    | 'B2B_EMPLOYER_REGISTRATION'
    | 'B2B_PROMO_PAGE_SEARCH'
    | 'B2B_EMPLOYER_PAGE_SEARCH'
    | 'B2B_RESUME_OPEN_FROM_PROMO_PAGE'
    | 'B2B_VACANCY_COMPLETE'
    | 'B2C_ALL_SITE'
    | 'B2C_MAIN_PAGE_SHOWN'
    | 'B2C_APPLICANT_AUTHORIZATION'
    | 'B2C_APPLICANT_REGISTRATION'
    | 'B2C_MAIN_PAGE_SEARCH'
    | 'B2C_VACANCY_RESPONSE_CLICK'
    | 'B2C_RESUME_COMPLETE'
    | 'EMPLOYER_REGISTRATION_SHOWN'
    | 'ZP_ALL_SITE'
    | 'ZP_ADD_WISHLIST'
    | 'ZP_VIEW_PRODUCT'
    | 'ZP_PURCHASE'
    | 'ZP_CALL'
    | 'ZP_B2B_ALL_SITE'
    | 'ZP_B2B_POST_VACANCY'
    | 'ZP_B2B_SEARCH_RESUME'
    | 'ZP_B2B_REGISTRATION';

type PixelHandlers = {
    weborama?: WcmConversionId;
    soloway?: SolowayPixelData;
    astraLab?: AstraLabEvent;
    adriver?: AdriverEventData;
};

export const PixelEventsMap: Record<PixelEventName, PixelHandlers> = {
    B2B_ALL_SITE: {
        soloway: {
            siteId: SolowaySiteIdAlias.B2B,
        },
        astraLab: 'TRACKING',
    },
    B2B_PROMO_PAGE_SHOWN: {
        weborama: WcmConversionIdAlias.HH_B2B_PAGE,
        soloway: {
            siteId: SolowaySiteIdAlias.B2B,
            eventId: 'vuJdxTeC',
        },
        astraLab: 'B2B_LANDING',
    },
    B2B_EMPLOYER_PAGE_SHOWN: {
        soloway: {
            siteId: SolowaySiteIdAlias.B2B,
            eventId: 'VlwLVrN8',
        },
    },
    B2B_EMPLOYER_AUTHORIZATION: {
        weborama: WcmConversionIdAlias.HH_AUTHORIZATION_EMPLOYER,
        soloway: {
            siteId: SolowaySiteIdAlias.B2B,
            eventId: 'VGcBSwDM',
        },
    },
    B2B_EMPLOYER_REGISTRATION: {
        weborama: WcmConversionIdAlias.HH_REGISTRATION_CLIENT,
        soloway: {
            siteId: SolowaySiteIdAlias.B2B,
            eventId: '9KEDxfxj',
        },
    },
    B2B_PROMO_PAGE_SEARCH: {
        soloway: {
            siteId: SolowaySiteIdAlias.B2B,
            eventId: 'Vwx5e7VT',
        },
    },
    B2B_EMPLOYER_PAGE_SEARCH: {
        soloway: {
            siteId: SolowaySiteIdAlias.B2B,
            eventId: 'akrO4dtC',
        },
    },
    B2B_RESUME_OPEN_FROM_PROMO_PAGE: {
        soloway: {
            siteId: SolowaySiteIdAlias.B2B,
            eventId: 'WPOP8bRE',
        },
    },
    B2B_VACANCY_COMPLETE: {
        soloway: {
            siteId: SolowaySiteIdAlias.B2B,
            eventId: 'um6r9DGP',
        },
    },
    B2C_ALL_SITE: {
        weborama: WcmConversionIdAlias.HH_ALL_SITE,
        soloway: {
            siteId: SolowaySiteIdAlias.B2C,
        },
    },
    B2C_MAIN_PAGE_SHOWN: {
        soloway: {
            siteId: SolowaySiteIdAlias.B2C,
            eventId: 't5Pcb1F2',
        },
    },
    B2C_APPLICANT_AUTHORIZATION: {
        weborama: WcmConversionIdAlias.HH_AUTHORIZATION_SOISKATEL,
        soloway: {
            siteId: SolowaySiteIdAlias.B2C,
            eventId: 'ls2PQx2c',
        },
    },
    B2C_APPLICANT_REGISTRATION: {
        weborama: WcmConversionIdAlias.HH_REGISTRATION_SOISKATEL,
        soloway: {
            siteId: SolowaySiteIdAlias.B2C,
            eventId: 'qlubM09K',
        },
    },
    B2C_MAIN_PAGE_SEARCH: {
        soloway: {
            siteId: SolowaySiteIdAlias.B2C,
            eventId: 'dtVa6q8i',
        },
    },
    B2C_VACANCY_RESPONSE_CLICK: {
        weborama: WcmConversionIdAlias.HH_B2C_CO_BRAND_START_OTCLICK,
        soloway: {
            siteId: SolowaySiteIdAlias.B2C,
            eventId: 'f9jWrwyL',
        },
    },
    B2C_RESUME_COMPLETE: {
        soloway: {
            siteId: SolowaySiteIdAlias.B2C,
            eventId: 'gyYB0ffi',
        },
    },
    EMPLOYER_REGISTRATION_SHOWN: {
        astraLab: 'EMPLOYER_REGISTRATION',
    },
    ZP_ALL_SITE: {
        adriver: {
            sid: 225536,
            event: 'page_view',
        },
    },
    ZP_ADD_WISHLIST: {
        adriver: {
            sid: 225536,
            event: 'rw_zp_add_wishlist',
        },
    },
    ZP_VIEW_PRODUCT: {
        adriver: {
            sid: 225536,
            event: 'rw_zp_view_product',
        },
    },
    ZP_PURCHASE: {
        adriver: {
            sid: 225536,
            event: 'rw_zp_purchase',
        },
    },
    ZP_CALL: {
        adriver: {
            sid: 225536,
            event: 'rw_zp_call',
        },
    },
    ZP_B2B_ALL_SITE: {
        adriver: {
            sid: 226174,
            event: 'rw_zp_b2b_all_site',
        },
    },
    ZP_B2B_POST_VACANCY: {
        adriver: {
            sid: 226174,
            event: 'rw_zp_b2b_post_vacancy',
        },
    },
    ZP_B2B_SEARCH_RESUME: {
        adriver: {
            sid: 226174,
            event: 'rw_zp_b2b_search_resume',
        },
    },
    ZP_B2B_REGISTRATION: {
        adriver: {
            sid: 226174,
            event: 'rw_zp_b2b_registration',
        },
    },
};
